import { useState } from 'react';
import { FiPlus, FiUpload } from 'react-icons/fi';
import AdminTables from '@components/admin/AdminTables';
import AdminForms from '@components/admin/AdminForms';
import Modal from '@components/common/Modal';
import Button from '@components/common/Button';

const AdminInventory = () => {
  const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  // Mock data - replace with real API
  const inventory = [
    {
      id: 1,
      productId: 'CAM-HD-100',
      productName: 'Security Camera HD-100',
      quantity: 45,
      shelfNumber: 'A-12',
      location: 'Warehouse A',
      lastUpdated: new Date().toISOString(),
    },
    {
      id: 2,
      productId: 'LOCK-PRO-01',
      productName: 'Smart Lock Pro',
      quantity: 12,
      shelfNumber: 'B-05',
      location: 'Warehouse A',
      lastUpdated: new Date().toISOString(),
    },
  ];

  const columns = [
    { key: 'productId', label: 'Product ID' },
    { key: 'productName', label: 'Product Name' },
    { 
      key: 'quantity', 
      label: 'Quantity',
      render: (value) => (
        <span className={`font-semibold ${
          value < 10 ? 'text-red-600' :
          value < 20 ? 'text-orange-600' :
          'text-green-600'
        }`}>
          {value}
        </span>
      )
    },
    { key: 'shelfNumber', label: 'Shelf' },
    { key: 'location', label: 'Location' },
    { 
      key: 'lastUpdated', 
      label: 'Last Updated',
      render: (value) => new Date(value).toLocaleDateString()
    },
  ];

  const formFields = [
    { name: 'productId', label: 'Product ID', type: 'text', required: true },
    { 
      name: 'quantity', 
      label: 'Quantity', 
      type: 'number', 
      required: true,
      validation: { min: 0 }
    },
    { name: 'shelfNumber', label: 'Shelf Number', type: 'text', required: true },
    {
      name: 'location',
      label: 'Location',
      type: 'select',
      required: true,
      options: [
        { value: 'Warehouse A', label: 'Warehouse A' },
        { value: 'Warehouse B', label: 'Warehouse B' },
        { value: 'Warehouse C', label: 'Warehouse C' },
      ]
    },
  ];

  const handleUpdate = (item) => {
    setSelectedItem(item);
    setIsUpdateModalOpen(true);
  };

  const handleSubmitUpdate = (data) => {
    console.log('Update inventory:', selectedItem.id, data);
    setIsUpdateModalOpen(false);
    setSelectedItem(null);
  };

  const handleDelete = (item) => {
    if (window.confirm(`Are you sure you want to remove ${item.productName} from inventory?`)) {
      console.log('Delete inventory item:', item.id);
    }
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="text-3xl font-bold text-gray-900">Inventory Management</h1>
          <p className="text-gray-600 mt-2">Track and manage warehouse stock levels</p>
        </div>
        <div className="flex space-x-4">
          <Button
            text="Bulk Upload"
            type="secondary"
            icon={<FiUpload />}
          />
          <Button
            text="Add Item"
            type="primary"
            onClick={() => setIsUpdateModalOpen(true)}
            icon={<FiPlus />}
          />
        </div>
      </div>

      {/* Stats Cards */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
        <div className="bg-white rounded-lg shadow-md p-6">
          <p className="text-gray-600 text-sm">Total Items</p>
          <p className="text-3xl font-bold text-gray-900 mt-2">347</p>
        </div>
        <div className="bg-white rounded-lg shadow-md p-6">
          <p className="text-gray-600 text-sm">Low Stock</p>
          <p className="text-3xl font-bold text-orange-600 mt-2">23</p>
        </div>
        <div className="bg-white rounded-lg shadow-md p-6">
          <p className="text-gray-600 text-sm">Out of Stock</p>
          <p className="text-3xl font-bold text-red-600 mt-2">8</p>
        </div>
        <div className="bg-white rounded-lg shadow-md p-6">
          <p className="text-gray-600 text-sm">Total Value</p>
          <p className="text-3xl font-bold text-green-600 mt-2">£125k</p>
        </div>
      </div>

      <AdminTables
        columns={columns}
        data={inventory}
        onEdit={handleUpdate}
        onDelete={handleDelete}
      />

      {/* Update/Add Modal */}
      <Modal
        isOpen={isUpdateModalOpen}
        onClose={() => {
          setIsUpdateModalOpen(false);
          setSelectedItem(null);
        }}
        title={selectedItem ? 'Update Inventory' : 'Add Inventory Item'}
      >
        <AdminForms
          fields={formFields}
          initialData={selectedItem}
          onSubmit={handleSubmitUpdate}
          submitButtonText={selectedItem ? 'Update' : 'Add'}
        />
      </Modal>
    </div>
  );
};

export default AdminInventory;

